<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备选择器-远程搜索
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="equipid" :placeholder="placeholder" filterable
    remote :remote-method="remoteMethod" clearable @change="selectChange" @focus="focus" :style="{ width: width + 'px' }">
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item.name"
      :value="item.equipid">
    </el-option>
  </el-select>
</template>

<script>
import { getEquipDynamicInfoApi } from '@/api/rms/rmsEquipApi'

export default {
  name: "FEquipSelector",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '设备'
    },

    width: {
			type: String,
			default: '160'
		}
  },

  data() {
    return {
      options: []
    }
  },

  computed: {
    equipid: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
    
  },

  created() {
    this.fetchData()
  },

  watch: {
  },

  methods: {
    remoteMethod(query) {
      getEquipDynamicInfoApi({ keyword: query, num: 10 }).then(res => {
        if (!res.errno) {
          this.options = res.data.list
        }
      })
    },

    focus() {
      if (!this.equipid) this.fetchData()
    },

    fetchData() {
      getEquipDynamicInfoApi().then(res => {
        if (!res.errno) {
          this.options = res.data.list
        }
      })
    },

    selectChange(val) {
      const list = this.options.map(v => v.equipid)
      const index = list.indexOf(val)
      const item = this.options[index]
      this.$emit('change', item)
    },

  }
}
</script>

<style lang="scss" scoped>
</style>
